/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type ReactNode } from 'react';

import { isString } from 'lodash-es';
import { I18n } from '@adp-arch/i18n';
// @ts-ignore - brand config is injected at build time in some environments
import { brandConfig } from 'brand-config';

export const renderHtmlTitle = (prefix?: ReactNode) => {
  const defaultTitle = brandConfig?.title || I18n.t('platform_name');
  if (isString(prefix) && prefix.trim()) {
    return `${prefix} - ${defaultTitle}`;
  }
  return defaultTitle;
};
